import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const ProfilePage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography>
          User profile information and settings will be displayed here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default ProfilePage;
